import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                close: 'close'
            }
        }
    }

    init() {
        this.id = this.el.getAttribute('data-guideflow-id');
        this.opened = false;
        
        document.querySelectorAll('.c-guideflow_open').forEach((elt) => {
            elt.addEventListener('click', (e) => {
                e.preventDefault();
                this.open(elt.getAttribute('data-guideflow-id'));
            });
        });
    }

    close() {
        this.opened = false;
        this.el.classList.remove('-visible');
        this.call('start','Scroll');
    }

    open(id) {
        if (id != this.id || this.opened) return;

        this.opened = true;
        this.el.classList.add('-visible');
        this.call('stop','Scroll');
    }
}
